module.exports = __webpack_public_path__ + "img/58.4b54201a.png";